const bssShippingObserver = new MutationObserver((mutations) => {
  const shippingLabels = document.querySelectorAll('.b2b-nt-shipping-method-option > div:last-child');

  if (shippingLabels.length > 0) {
    shippingLabels.forEach(label => {
      if (label.textContent.trim() === 'Free') {
        label.textContent = 'Gratis';
      }
    });
  }
});

bssShippingObserver.observe(document.body, {
  childList: true,
  subtree: true
});

(function () {
    function handleRemoveNewAddressOption() {
        const addressSelect = document.querySelector("#b2b-nt-address-select");
        if (!addressSelect) return;

        const newOption = addressSelect.querySelector('option[value="new"]');
        if (newOption) {
        newOption.remove();
        }

        if (addressSelect.options.length > 0) {
        if (addressSelect.value === "" || addressSelect.value === "new") {
            addressSelect.selectedIndex = 0;
        }

        addressSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }
    }

    document.addEventListener("bss_b2b:render_nt_modal_done", function () {
        setTimeout(handleRemoveNewAddressOption, 0);
    });

    const observer = new MutationObserver(function (mutations) {
        for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) {
            if (
                node.id === "b2b-nt-modal" ||
                node.querySelector?.("#b2b-nt-address-select")
            ) {
                handleRemoveNewAddressOption();
            }
            }
        }
        }
    });

    if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
    } else {
        document.addEventListener("DOMContentLoaded", function () {
        observer.observe(document.body, { childList: true, subtree: true });
        });
    }
})();
